import React, { useState } from 'react';
import {
    EditFilled
} from '@ant-design/icons';
import {
    Button,
    Form,
    Modal,
    Row,
    Col,
    InputNumber,
    Statistic,
    Typography,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function EditFormModal({ data, formOrder, productItems }) {
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutation({
        mutationFn: ({ values, id }) => {
            axios
                .put(`/api/cartItem/${id}`, values)
                .then(res => {

                   
                    const { total_price } = res.data
                    const cartItems = productItems.filter(f => f._id !== id)

                    const grand_total = cartItems.reduce((prev, cur) => prev + cur.total_price, 0) + total_price;
                    let total = grand_total;
                    let vat = 0;

                    if (formOrder.getFieldValue("vatFlag") === 'ราคารวมภาษี') {
                        total = grand_total / 1.07;
                        vat = grand_total - total;
                    }
                    formOrder.setFieldsValue({
                        ...formOrder.getFieldsValue(true),
                        total,
                        vat,
                        grand_total
                    });

                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => {
                            queryClient.invalidateQueries(['/api/cartItem/getOrderCartItems']);
                            setOpen(false);
                        }
                    });

                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });


    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate({
                values: {
                    ...values,
                    total_price: (values.price * values.quantity) - values.discount,
                    selling_price: values.price - (values.discount / values.quantity)
                },
                id: data._id
            }))
            .catch(err => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                });
            })
    };

    const onCancelCreate = () => {
        setOpen(false);
    }
    // console.log(data);
    return (
        <div>
            {contextHolder}
            <Button
                type='text'
                icon={<EditFilled />}
                style={{ color: '#5f77fc' }}
                onClick={() => setOpen(true)} />
            <Modal
                open={open}
                title={`แก้ไขสินค้า ${data.product.name}:${data.product.brand.name} ${data.product.description}`}
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        ยกเลิก
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        ตกลง
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name={`edit${data._id}`}
                    initialValues={data}
                >
                    <Row gutter={[8, 8]}>
                        <Col xs={8}>
                            <Form.Item
                                label="ราคา"
                                name="price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} disabled style={{ width: "100%", background: '#FFF', color: "#000" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={8}>
                            <Form.Item
                                label="จำนวน"
                                name="quantity"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={1} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={8}>
                            <Form.Item
                                label="ส่วนลด"
                                name="discount"
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify="end">
                        <Col >
                            <Form.Item shouldUpdate>
                                {() => {

                                    return <Statistic
                                        title={<Typography.Title level={4}>รวม :</Typography.Title>}
                                        value={(form.getFieldValue('price') * form.getFieldValue('quantity')) - form.getFieldValue('discount')}
                                        precision={2}
                                        valueStyle={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'end' }}
                                    />
                                }}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>

    )
}
